import React from 'react';
import GirviPageShell from '../components/common/GirviPageShell';
import VatavTransferPanel from '../components/common/vatav/VatavTransferPanel';

export default function VatavTransferPage() {
  return (
    <GirviPageShell title="Transfer to Vatav" subtitle="VPS B" chipLabel="VATAV" compact>
      <VatavTransferPanel />
    </GirviPageShell>
  );
}
